module.exports = __webpack_public_path__ + "img/agriculture-detail.cc56fd5f.jpg";